import { useEffect, useState } from 'react';
import { ModalArea } from '../../common/ModalButtonArea';
import './SubmitPopUp.scss';
import icons from '../../assets';
import { BigButton } from '../../common';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCurrentRequestSubPageId,
  resetState,
  requestsSelector,
  getCurrentPage,
  setHasNoModelLeft,
} from '../../redux/slicers/requestSlicer';
import { useNavigate } from 'react-router-dom';
import RequestDetails from '../../screens/Requests/RequestDetails';
import {
  apiGetRequest,
  apiInjectRequest,
  apiPostRequestComment,
  apiSubmitRequest,
} from '../../helpers/api';
import { getFormattedTime, updateRequestPage } from '../../screens/Requests/Sections/helper';
import { getLocalStorage, openFormInCaseOfNewOrgAndFreemiumUser, windowOpen } from '../../helpers/jsHelper';
import { PERMISSION, PERMISSIONS } from '../../constants/permissionConstants';
import { AddAddonCart, GetAllCartProductList, removeAllItemsFromCart, setAllProductsUsedCount } from '../../api/subscription/subscription';
import { usePermissionsHandler } from '../../hooks/usePermissions';
import { selectAddonsList, selectAvailable3DModelUploadLimit, selectAvailable3DModelVariationsWithoutDivide } from '../../redux/slicers/subscriptionSlicer';
import { checkIfEmailIsVerifiedOrNotFromApi, useUserContext } from '../../contexts/UserContext';
import { REQUESTS_ROUTE } from '../../config/constant/routePathConstant';
import {
  ADMIN_SETTINGS,
  MY_PLANS_ROUTE,
  NEW_REQUEST_ROUTE,
  PRICING_ROUTE,
  REQUEST_DETAIL_ROUTE,
} from '../../constants/routePathConstants';
import { useInfoDialogaActions } from '../../hooks/useInfoDialogaActions';
import { THREE_D_MODEL_PRODUCT_NAME, THREE_D_MODEL_VARIATION_PRODUCT_NAME, navigateToPlans, removeParamsFromUrl } from '../../screens/subscriptionComponents/subscriptionHelper';
import useCurrentOrganizationInfo from '../../hooks/useCurrentOrganizationInfo';
import { NEW_MODAL, SETTINGS_TAB } from '../../constants/constants';
import { dispatcher } from '../../helpers/projectHelper';

function SubmitPopUp() {
  const { handlePermissionEvent } = usePermissionsHandler();
  const { isOldSubscriptionPlan } = useUserContext();
  const _requestSelector = useSelector(requestsSelector);
  const available3DModelVariations = useSelector(selectAvailable3DModelVariationsWithoutDivide);
  const available3DModelUploadLimit = useSelector(selectAvailable3DModelUploadLimit);
  const { results: addonsList } = useSelector(selectAddonsList);
  const modelType = _requestSelector?.purchasedInfo
    ? _requestSelector?.purchasedInfo?.data?.[0]?.price?.is_existing_model
      ? '2'
      : '1'
    : _requestSelector.requestPages[1].data.parent;
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [payNowLoading, setPayNowLoading] = useState(false);
  const [mainModalShow, setMainModalShow] = useState(true);
  const [insufficientLimit, setInsufficientLimit] = useState(false);

  const { currentUser, isGuestUser } = useUserContext();
  const { isFreemiumOrSelfServeUser, hideNewPlans } = useCurrentOrganizationInfo();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentPage = useSelector(getCurrentPage);

  const { openInfoDialog } = useInfoDialogaActions();

  const { results: allData } = useSelector(selectAddonsList);
  // For guest users, we do not call the counts API, so sometimes the counts are not updated.  
  // To ensure accuracy, I call the getCounts API here.

  useEffect(() => {
    dispatch(setAllProductsUsedCount())
  }, []);
  
  const threeDModel = allData?.find((a) => a.basemodeltype?.toLowerCase() === '3d model');
  const threeDModelVariation = allData?.find(
    (a) => a.basemodeltype?.toLowerCase() === '3d model variation'
  );

  const LINE_1 = insufficientLimit
    ? (isOldSubscriptionPlan || !available3DModelVariations ? 'Insufficient model variation limit.': 'Insufficient model upload limit.')
    : !_requestSelector.hasNoModelLeft
    ? 'Your request has been submitted.'
    : 'No free requests left.';
  const LINE_2 = insufficientLimit
    ? (isOldSubscriptionPlan || !available3DModelVariations ? 'You’ve reached your model variation limit. Please upgrade your plan to add more variations.'
      : 'You’ve reached your upload limit. Please upgrade your plan to upload more models.')
    : !_requestSelector.hasNoModelLeft
    ? 'Our team will review your request and get back to you in 24 hours.'
    : isGuestUser()
    ? 'No models available in this organization. Contact admin to add models for your client.'
    : 'You don’t have any free models requests left. Please pay to proceed with the request.';
  const LINE_3 = !_requestSelector.hasNoModelLeft ? 'You can check your request status at ' : '';

  const BUTTON_1_TITLE = insufficientLimit
    ? 'Upgrade plan'
    : !_requestSelector.hasNoModelLeft
    ? 'Add new request'
    : 'Pay now';
  const BUTTON_2_TITLE = !_requestSelector.hasNoModelLeft ? 'Cancel' : 'See subscription plans';

  const addToCart = (value, quantity, redirect) => {
    handlePermissionEvent(
      PERMISSION.SUBSCRIPTION,
      async (r) => {
        if (r === undefined) {
          let payload = {
            subscription_price: value,
            quantity: quantity,
          };

          const response = await AddAddonCart(payload, 'add');
          if (response?.status) {
            if (redirect) {
              setPayNowLoading(false);
              if (isFreemiumOrSelfServeUser) {
                windowOpen(`${ADMIN_SETTINGS}?activeTab=${SETTINGS_TAB.PLANS}`, '_blank');
              } else {
                windowOpen(
                  `${ADMIN_SETTINGS}?activeTab=${SETTINGS_TAB.ADD_ONS}&checkout=true`,
                  '_blank'
                );
              }
            }
          }
        } else setPayNowLoading(false);
      },
      PERMISSIONS.SUBSCRIPTION.warningMessage
    )();
  };

  const handleButton1Click = () => {
    if (insufficientLimit) {
      if (hideNewPlans) { // open enterprise form in case of freemium user whose org is created after 10th Feb 2025
        openFormInCaseOfNewOrgAndFreemiumUser();
        return;
      }
      let url = '/settings?activeTab=plans&browsePlan=true';
      if (isFreemiumOrSelfServeUser) {
        // url = PRICING_ROUTE
        url = MY_PLANS_ROUTE;
      }
      windowOpen(url, '_blank');
      return;
    }
    if (_requestSelector.hasNoModelLeft) {
      const _subscription_price = modelType === '1' ? threeDModel?.id : threeDModelVariation?.id;
      const other = modelType === '1' ? threeDModelVariation?.id : threeDModel?.id;
      setPayNowLoading(true);

      addToCart(other, 0, false);
      addToCart(_subscription_price, 1, true);
    } else {
      dispatch(resetState());
      navigate(NEW_REQUEST_ROUTE, { replace: true });
    }
  };

  const handleButtonBuyProduct = async () => {
    if (hideNewPlans) { // open enterprise form in case of freemium user whose org is created after 10th Feb 2025
      openFormInCaseOfNewOrgAndFreemiumUser();
      return;
    }
    const redirectURL = window.location.href
    let is3dModel = modelType === '1'
    const baseTypeName = is3dModel ? THREE_D_MODEL_PRODUCT_NAME : THREE_D_MODEL_VARIATION_PRODUCT_NAME
    if (is3dModel) {
      is3dModel = addonsList?.find(
        ({ basemodeltype }) => basemodeltype === baseTypeName
      );
    }
    const addonsItem =
      is3dModel ||
      addonsList?.find(({ basemodeltype }) =>
        basemodeltype === baseTypeName
      );
     // Sometimes, the subscription price ID does not match because it is from the current add-ons list, so we take the latest ID from the list.
     const subscriptionPriceId = addonsList?.find(({basemodeltype, prices})=> (prices?.length && basemodeltype === addonsItem?.basemodeltype))?.id || null 
     if (addonsItem?.id || subscriptionPriceId) {
      setPayNowLoading("buyProduct");
      await dispatcher(GetAllCartProductList());
      let payload = {
        subscription_price: subscriptionPriceId || addonsItem?.id,
        quantity: 1,
      };
      await removeAllItemsFromCart();
      const response = await AddAddonCart(payload, 'add');
      await dispatcher(GetAllCartProductList());
      if (response?.status) {
        let tab = SETTINGS_TAB.ADD_ONS;
        if (isFreemiumOrSelfServeUser) {
          tab = SETTINGS_TAB.PLANS;
        }
        navigate(
          `${ADMIN_SETTINGS}?activeTab=${tab}&checkout=true&is_one_time=true&interval=1&referrer=${redirectURL}`
        );
      }
      setTimeout(() => {
        setPayNowLoading(false);
      }, 1000);
    }
  };

  const handleClickRequestPage = () => {
    navigate(REQUESTS_ROUTE, { replace: true });
  };

  function onClose() {
    if (!_requestSelector.hasNoModelLeft)
      updateRequestPage(
        currentPage,
        dispatch,
        {
          data: { ..._requestSelector.requestData, isSubmitted: true },
        },
        _requestSelector
      );
    setPayNowLoading(false);
    setShow(false);
  }

  function onMainModalClose() {
    setMainModalShow(false);
    dispatch(setCurrentRequestSubPageId(null));
  }

  const onButton2Click = (isSubmitPopup = false) => {
    onClose();
    if (isSubmitPopup && !_requestSelector.hasNoModelLeft)
      navigate(REQUESTS_ROUTE, { replace: true });
    if (_requestSelector.hasNoModelLeft) navigateToPlans({ newTab: true });
  };

  const onSubmitRequest = async () => {
    setLoading(true);
    if (!(await checkIfEmailIsVerifiedOrNotFromApi())) {
      setLoading(false);
      return;
    }

    const _request = await apiGetRequest(_requestSelector?.currentRequestId);
    if (_request && _request.model_request.status === 'SUBMITTED') {
      openInfoDialog({
        title: 'This request has already been submitted.',
        buttonText: 'Go to request',
        onButtonClick: () =>
          navigate(REQUEST_DETAIL_ROUTE.replace(':id', _requestSelector?.currentRequestId), {
            replace: true,
          }),
        cancelButtonText: 'Cancel',
        onCancelClick: () => navigate(REQUESTS_ROUTE, { replace: true }),
      });
      return;
    }

    // let response;

    // if (!_requestSelector.purchasedInfo) {
    //   const _formData = new FormData();
    //   if (_requestSelector?.requestPages[1]?.data?.parent === '1')
    //     _formData.append('type', 'SCRATCH');
    //   else _formData.append('type', 'INGEST');
    //   _formData.append(
    //     'organization_id',
    //     JSON.parse(getLocalStorage('current_user'))?.organization
    //   );

    //   _formData.append('model_id ', _requestSelector?.currentRequestId);
    //   await apiInjectRequest(_formData, null, null, (data) => {
    //     response = data;
    //   });
    // }

    const requiredCount = isOldSubscriptionPlan && _request?.request_model_type === NEW_MODAL ? 2 : 1
    const availableCount = isOldSubscriptionPlan ? available3DModelVariations : available3DModelUploadLimit
    const bothCountAvailable = (isOldSubscriptionPlan && +available3DModelVariations > 0) ? true : (+available3DModelVariations > 0 && +available3DModelUploadLimit > 0)
  
    if (+requiredCount > +availableCount || !bothCountAvailable) {
      setInsufficientLimit(true);
      // if (response?.data?.upload_limit === 0) {
      //   setInsufficientLimit(true);
      // }
      dispatch(setHasNoModelLeft(true));
      setShow(true);
    } else {
      dispatch(setHasNoModelLeft(false));
      const formData = new FormData();
      formData.append('message', 'Your request has been submitted successfully.');

      if (_requestSelector?.purchasedInfo) formData.append('is_pack_finallized', true);
      const _response = await apiSubmitRequest(_requestSelector.currentRequestId, formData);
      if (_response?.status) {
        setShow(true);
        var currentdate = new Date();
        const _formData = new FormData();
        _formData.append('is_status_change', true);
        _formData.append('is_status', true);
        _formData.append('model_request', _requestSelector?.currentRequestId);
        _formData.append(
          'message',
          `Request submitted by <b>${currentUser.user.first_name} ${
            currentUser.user.last_name
          }</b> on <b>${getFormattedTime(currentdate)}</b>`
        );

        await apiPostRequestComment(_formData);
      }
    }

    setLoading(false);
  };

  const { RightCheckIcon } = icons;
  return (
    <div>
      <ModalArea
        showModal={mainModalShow}
        setShowModal={onMainModalClose}
        className="reviewRequestModal"
        parentClassName="reviewParentRequestModal"
        centered
        size="xl"
        body={
          <div className="d-flex flex-column gap-3">
            <RequestDetails hideComments={true} />
            <BigButton
              disabled={loading}
              isLoading={loading}
              className="request-submit-button"
              onClick={onSubmitRequest}>
              Submit Request
            </BigButton>
          </div>
        }
      />

      <ModalArea
        showModal={show}
        setShowModal={onClose}
        className="submitRequestModal"
        parentClassName="submitParentRequestModal"
        centered
        body={
          <div className="d-flex flex-column align-items-start gap-2">
            {!_requestSelector.hasNoModelLeft && (
              <div className="icon-wrapper">
                <RightCheckIcon />
              </div>
            )}
            <span>{LINE_1}</span>
            <span className="text-muted">{LINE_2}</span>
            <span className="text-muted">
              {LINE_3}
              {_requestSelector?.purchasedInfo ? (
                'Request page.'
              ) : !_requestSelector.hasNoModelLeft ? (
                <a onClick={handleClickRequestPage}>Request Page.</a>
              ) : null}
            </span>

            {!isGuestUser() && !_requestSelector?.purchasedInfo ? (
              <>
                <BigButton
                  isLoading={payNowLoading && payNowLoading !== 'buyProduct'}
                  onClick={handleButton1Click}>
                  {BUTTON_1_TITLE}
                </BigButton>
                {insufficientLimit && (
                  <BigButton
                    isLoading={payNowLoading && payNowLoading === 'buyProduct'}
                    onClick={handleButtonBuyProduct}>
                    Buy
                  </BigButton>
                )}
              </>
            ) : _requestSelector?.purchasedInfo ? (
              <BigButton isLoading={payNowLoading} onClick={handleClickRequestPage}>
                Go to Request page
              </BigButton>
            ) : null}
            {!isGuestUser() && _requestSelector.hasNoModelLeft && !insufficientLimit ? (
              <BigButton className="secondary" onClick={() => onButton2Click(true)}>
                {BUTTON_2_TITLE}
              </BigButton>
            ) : null}
            {_requestSelector.hasNoModelLeft && (
              <a className="mx-auto" onClick={onClose}>
                Cancel
              </a>
            )}
          </div>
        }
      />
    </div>
  );
}

export default SubmitPopUp;
